import { render, staticRenderFns } from "./new.vue?vue&type=template&id=1db0ade9&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"
import style0 from "./new.vue?vue&type=style&index=0&id=1db0ade9&prod&lang=less"
import style1 from "./new.vue?vue&type=style&index=1&id=1db0ade9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0ade9",
  null
  
)

export default component.exports